export default function PhoneMockup() {
  return (
    <div className="relative flex items-center justify-center" data-testid="phone-mockup">
      {/* Violet ambient glow */}
      <div className="absolute inset-0 -z-10 blur-3xl animate-pulseGlow">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[420px] h-[420px] rounded-full bg-violet-500/40" />
      </div>

      {/* App screenshot */}
      <div className="relative animate-float w-[300px] sm:w-[360px] lg:w-[400px] rounded-[2.5rem] overflow-hidden shadow-[0_30px_80px_-20px_rgba(124,58,237,0.45)]">
        <img
          src="https://customer-assets.emergentagent.com/job_lift-minimal/artifacts/5wx3asmp_ASO%20Scan.jpg"
          alt="Aperçu de l'application Lift AI — scan du physique"
          className="w-full h-auto block"
          loading="eager"
        />
      </div>
    </div>
  );
}
